// extracted by mini-css-extract-plugin
module.exports = {"budgetIsland":"AnalyticsBudget_budgetIsland__bdxZA","heading":"AnalyticsBudget_heading__2za5G"};